import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AttachmentBase } from 'src/sb-tools/typescript/models/attachment-base.model';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'filterContentAttachments' })
export class FilterContentAttachmentsPipe implements PipeTransform {
    // attachmentsLength - here used to detect changes
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transform(attachments: AttachmentBase[], isContentPart: boolean, attachmentsLength: number): AttachmentBase[] {
        if (attachments && attachments.length) {
            return attachments.filter((attachment) => {
                return isContentPart ? attachment.isContentPart : !attachment.isContentPart;
            });
        } else {
            return [];
        }
    }
}
